/* eslint-disable no-case-declarations */
import React from 'react';
import {
	TextField, Select, MenuItem, InputLabel, FormControl, FormHelperText, Chip
} from '@material-ui/core';
import { Controller } from 'react-hook-form';
import { makeStyles } from '@material-ui/core/styles';

const getErrorString = (errors, params) => {
	const { name, maxFiles } = params;
	if (!errors || !Object.keys(errors).length) return '';

	let type;
	if (name.indexOf('.') === -1 && errors[name]) {
		type = errors[name].type;
	} else {
		name.split('.').map((val) => {
			type = !type ? errors[val] : type[val];
			return null;
		});
		type = type && type.type;
	}
	if (!type) return '';
	switch (type) {
	case 'addressRequired':
	case 'imageRequired':
	case 'required':
		return 'This is a required field.';
	case 'minLength':
		return 'Password should be at least 8 characters long';
	case 'validate':
		return 'Passwords are not matching';
	case 'pattern':
		return 'Invalid value';
	case 'imageMaxImages':
		return `The maximum number of file is ${maxFiles}.`;
	default:
		return 'Unknown validation error. Need to be implemented - TBD';
	}
};

const ReactHookFormInput = (props) => {
	const {
		setValue,
		validationHook,
		validation,
		getAddressValue,
		getImageFiles,
		useFormHooks,
		useFormHooks1,
		...others
	} = props;
	const {
		register,
		formState: { errors },
		control,
	} = useFormHooks1 || useFormHooks;

	const useStyles = makeStyles((theme) => ({
		chips: {
			display: 'flex',
			flexWrap: 'wrap',
		},
		chip: {
			margin: 2,
			backgroundColor: theme.palette.primary.main,
			color: 'white',
			fontWeight: 600
		}
	}));

	const classes = useStyles();

	if (!register) return null;
	if (!others || !others.type) return null;

	const getInputRender = (params) => {
		const { onChange, value } = (params && params.field) || {};
		switch (others.type) {
		case 'Multi_Picklist':
		case 'Picklist':
			const errorStringInput = getErrorString(errors, others);

			const handleChange = (event) => {
				onChange(event);
			};

			const picklistError = errorStringInput || '';

			return (
				<FormControl variant={others.variant} style={{ minWidth: '100%', marginTop: '10px' }}>
					<InputLabel
						error={picklistError !== ''}
						id="demo-simple-select-outlined-label"
					>
						{others.label}
					</InputLabel>
					<Select
						labelId="demo-simple-select-outlined-label"
						id="demo-simple-select-outlined"
						// eslint-disable-next-line no-nested-ternary
						value={others.type === 'Multi_Picklist' ? (value ? [...value] : []) : value}
						multiple={others.type === 'Multi_Picklist'}
						onChange={handleChange}
						label={others.label}
						error={picklistError !== ''}
						style={{ width: '100%' }}
						renderValue={others.type === 'Multi_Picklist' ? ((selected) => (
							<div className={classes.chips}>
								{selected.map((value) => (
									<Chip key={value} label={value} className={classes.chip} />
								))}
							</div>
						))
							: null}
					>
						{others.picklist.map((el) => (
							<MenuItem key={el} value={el}>{el}</MenuItem>
						))}
					</Select>
					<FormHelperText error>{picklistError}</FormHelperText>
				</FormControl>
			);
		default:
			const errorString = getErrorString(errors, others);
			const inputProps = errorString ? { ...others, error: true, helperText: errorString } : { ...others };
			delete inputProps.displayName;
			if (others.type === 'checkbox') {
				inputProps.defaultChecked = others.defaultValue;
			}
			return (
				<TextField
					className={others.type === 'checkbox' ? 'ml-0' : ''}
					onKeyPress={(e) => (
						e.key === 'Enter' && e.preventDefault()
					)}
					// eslint-disable-next-line react/jsx-props-no-spreading
					{...inputProps}
					onChange={(e) => {
						if (others.type === 'number') {
							const output = parseInt(e.target.value, 10);
							onChange(output);
							if (others.onChange) others.onChange(output);
							return;
						}
						onChange(e);
						if (others.onChange) others.onChange(e);
					}}
				/>
			);
		}
	};

	return (
		<div>
			<Controller
				control={control}
				name={others.name}
				defaultValue={others.defaultValue}
				rules={validation}
				render={getInputRender}
			/>
		</div>
	);
};

export default ReactHookFormInput;
